import { z } from "zod";

export enum BillStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  CANCELED = "CANCELED",
}

export const BillsDto = z.object({
  id: z.string(),
  status: z.nativeEnum(BillStatus),
  total: z.number(),
  date: z.string().transform((date) => new Date(date)),
  url: z.string().optional(),
});

export type BillsDto = z.infer<typeof BillsDto>;
